/**
 * 关闭广告
 * @param material 传入
 *
 */
import { safeParse } from "@/utils/safeParse";
export default function setCloseAds(material) {
  if (!material) {
    return;
  }
  var exp = new Date();
  exp.setTime(exp.getTime() + 12 * 60 * 60 * 1000);
  const value = materialIdList(material);
  document.cookie = `_excludes=${value};expires=${exp.toGMTString()};domain=.huaban.com;path=/;`;
}

export const materialIdList = (material) => {
  const name = "_excludes=";
  const ca = document.cookie.split(";");
  const result = ca.find((item) => {
    return item.includes(`${name}`);
  });
  if (result) {
    const formatList = result.split("=")[1];
    let data = decodeURIComponent(`${formatList}`);
    let list = [
      ...new Set([...Object.values(safeParse(data)), material.id]),
    ].flat(2);
    const farmatList = encodeURIComponent(`{"materials":[${list}]}`);
    return farmatList;
  } else {
    const value = encodeURIComponent(`{"materials":[${material.id}]}`);
    return value;
  }
};
